//NewsData
export const TOOLBAR_FILTRES = [
  {
    name: "periods",
    enabled: true,
    required: true,
    attrList: { showTime: true, date_begin: { selectOtherMonths: true }, date_end: { selectOtherMonths: true } },
    default: "За год",
  }
];

export const DICTIONARY = [{ options: "news_severity", entityName: 'news_severity', serviceName: 'BaseService', save: { store: false, self: true }, load: "db", scheme: "news" }];

export const COLUMNS = [
  {
    header: "ID",
    field: "news_id",
    sortable: true,
    bodyStyle: "text-align: right; width:65px;",
    filterData: {
      type: "InputText",
      attrList: { type: "number", step: "1" },
      placeholder: "...",
    },
  },
  {
    header: "Важность",
    field: "news_severity_name",
    sortable: true,
    filterData: {
      options: "news_severity",
      type: "MultiSelect",
      mode: "in",
      "max-width": "250px",
    },
  },
  {
    header: "Заголовок",
    field: "news_title",
    sortable: true,
    filterData: {
      type: "InputText",
    },
  },
  {
    header: "Содержание",
    field: "news_desc",
    dataType: "text"
  },
  {
    header: "Роли",
    field: "role_names",
  },
  {
    header: "Сервера",
    field: "server_prod_ids",
  },
  {
    header: "Подразделения",
    field: "depts_names",
  },
  {
    header: "Дата начала",
    field: "date_begin",
    sortable: true,
    dataType: "date-gmt",
    conversion: true,
    headerStyle: "width: 140px",
    filterData: {
      type: "Calendar",
      mode: "dateIsGMT",
      attrList: { dateFormat: "dd.mm.yy" },
    },
  },
  {
    header: "Дата окончания",
    field: "date_end",
    sortable: true,
    dataType: "date-gmt",
    conversion: true,
    headerStyle: "width: 140px",
    filterData: {
      type: "Calendar",
      mode: "dateIsGMT",
      attrList: { dateFormat: "dd.mm.yy" },
    },
  },
  {
    header: "Готовность",
    field: "row_is_ready",
    bodyStyle: "text-align: center;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
  },
];

//NewsDialog
export const DICTIONARY_DIALOG = [
  {
    options: "roles",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "role",
    entitySpec: "data",
  },
  {
    options: "servers",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "server_prod",
    entitySpec: "ref",
  },
  {
    options: "depts",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "dept",
    entitySpec: "ref",
  },
];

export const COLUMNS_AUDIT = [
  {
    header: "ID",
    field: "news_user_id",
    bodyStyle: "text-align: right; width:65px;",
  },
  {
    header: "Логин",
    field: "user_name",
  },
  {
    header: "Пользователь",
    field: "user_struct_name",
  },
  {
    header: "Дата просмотра",
    field: "create_date",
    dataType: "date-time-gmt",
    conversion: true,
  },
  {
    header: "Дата выключения",
    field: "disable_date",
    dataType: "date-time-gmt",
    conversion: true,
  },
];